import React from 'react';
import { renderContent } from '../renderContent';

export default function CourseNavigationSidebar({
    sidebarEntries,
    activeNotionId,
    setActiveNotionId,
    mainScrollEl,
    onItemClick
}) {
    const handleNotionClick = (nId) => {
        setActiveNotionId(String(nId));
        onItemClick?.();
        const el = document.getElementById(`notion-${nId}`);
        const scrollEl = mainScrollEl.current;
        if (el && scrollEl) {
            const top = el.getBoundingClientRect().top - scrollEl.getBoundingClientRect().top + scrollEl.scrollTop - 32;
            scrollEl.scrollTo({ top, behavior: 'smooth' });
        }
    };

    const handleHeadingClick = (hId) => {
        onItemClick?.();
        const el = document.getElementById(`section-${hId}`);
        const scrollEl = mainScrollEl.current;
        if (el && scrollEl) {
            const top = el.getBoundingClientRect().top - scrollEl.getBoundingClientRect().top + scrollEl.scrollTop - 32;
            scrollEl.scrollTo({ top, behavior: 'smooth' });
        }
    };

    if (!sidebarEntries || !sidebarEntries.length) return null;

    return (
        <ul className="space-y-0.5 w-full">
            {sidebarEntries.map(n => {
                const isActive = String(n.id) === String(activeNotionId);
                return (
                    <li key={n.id}>
                        <button
                            data-sidebar-id={n.id}
                            aria-current={isActive ? 'true' : undefined}
                            onClick={() => handleNotionClick(n.id)}
                            className={`w-full text-left px-3 py-1.5 rounded-lg text-xs transition-all duration-150 flex items-start gap-2 group ${
                                isActive
                                    ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-cyan-400 font-semibold'
                                    : 'text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-white/[0.04] hover:text-gray-800 dark:hover:text-gray-200'
                            }`}
                        >
                            <span className={`shrink-0 font-mono text-[10px] mt-0.5 ${isActive ? 'text-blue-400 dark:text-cyan-500' : 'text-gray-400 dark:text-gray-600'}`}>
                                {n.number}
                            </span>
                            <span className="leading-snug [&_p]:inline [&_p]:m-0">{renderContent(n.name)}</span>
                        </button>
                        {isActive && n.headings && n.headings.length > 0 && (
                            <ul className="mt-0.5 mb-1 space-y-0.5">
                                {n.headings.map(h => (
                                    <li key={h.id}>
                                        <button
                                            onClick={() => handleHeadingClick(h.id)}
                                            className="w-full text-left py-1 pl-5 pr-2 rounded text-[11px] text-gray-400 dark:text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 transition-colors leading-snug"
                                        >
                                            <span className="[&_p]:inline [&_p]:m-0">{renderContent(h.text)}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </li>
                );
            })}
        </ul>
    );
}
